<form [formGroup]="hospitalAdmissionsForm">
  <div class="step-container">
    <ng-template #labelHospitalAdmissions>{{ getTranslation('hospital.title') }}</ng-template>
    <div class="step-title">
      {{ isEditable ? getTranslation('hospital.title') : getTranslation('hospital.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>


    <div *ngIf="isJsonShow">
      {{hospitalAdmissionsForm.value | json}}
    </div>






    <div class="form-group col-12 mb-3">
      <div class="row">
        <label class="form-label col-md-5 mb-0"
          [ngClass]="{'text-danger': hospitalAdmissionsForm.controls['IsPastHospitalised'].invalid && submitted}">
          {{ getTranslation('hospital.question.pastHospitalized') }} <span class="text-danger">*</span></label>
        <div class="col-md-4 d-flex align-items-center">
          <label class="mr-5"><input type="radio" formControlName="IsPastHospitalised" [value]="true">
            {{ getTranslation('common.yes') }}</label>
          <label><input type="radio" formControlName="IsPastHospitalised" [value]="false"> {{ getTranslation('common.no') }}</label>
          <div *ngIf="submitted && hospitalAdmissionsForm.controls['IsPastHospitalised'].invalid"
            class="text-danger-val">
            {{ getTranslation('validation.requiredField') }}
          </div>
        </div>
      </div>
    </div>


  
    <div class="form-group col-12 mb-3"
      *ngIf="hospitalAdmissionsForm.get('IsPastHospitalised')?.value === true">
      <label for="HospitalAdmission" class="form-label">{{ getTranslation('hospital.pleaseDescribe') }}</label>
      <input type="text" class="form-control" id="HospitalAdmission" formControlName="HospitalAdmission" [maxlength]="CONSTANTS.MaxLength.inputTextDescription"
        placeholder="{{ getTranslation('hospital.enterDetails') }}">
      <!-- Error message when the field is required and empty -->
      <div *ngIf="submitted && hospitalAdmissionsForm.controls['HospitalAdmission']?.errors?.['required']"
        class="text-danger">
        {{ getTranslation('validation.requiredField') }}
      </div>


    </div>


















    
    <div class="form-group col-12 mb-3">
      <div class="row">
        <label class="form-label col-md-5 mb-0"
          [ngClass]="{'text-danger': hospitalAdmissionsForm.controls['IsSurgeryDone'].invalid && submitted}">
          {{ getTranslation('hospital.question.surgeryDone') }} <span class="text-danger">*</span></label>
        <div class="col-md-4 d-flex align-items-center">
          <label class="mr-5"><input type="radio" formControlName="IsSurgeryDone" [value]="true">
            {{ getTranslation('common.yes') }}</label>
          <label><input type="radio" formControlName="IsSurgeryDone" [value]="false"> {{ getTranslation('common.no') }}</label>
          <div *ngIf="submitted && hospitalAdmissionsForm.controls['IsSurgeryDone'].invalid"
            class="text-danger-val">
            {{ getTranslation('validation.requiredField') }}
          </div>
        </div>
      </div>
    </div>


  
    <div class="form-group col-12 mb-3"
      *ngIf="hospitalAdmissionsForm.get('IsSurgeryDone')?.value === true">
      <label for="SurgeryDetails" class="form-label">{{ getTranslation('hospital.pleaseDescribe') }}</label>
      <input type="text" class="form-control" id="SurgeryDetails" formControlName="SurgeryDetails" [maxlength]="CONSTANTS.MaxLength.inputTextDescription"
        placeholder="{{ getTranslation('hospital.enterDetails') }}">
      <!-- Error message when the field is required and empty -->
      <div *ngIf="submitted && hospitalAdmissionsForm.controls['SurgeryDetails']?.errors?.['required']"
        class="text-danger">
        {{ getTranslation('validation.requiredField') }}
      </div>


    </div>




















    <!-- Surgeries -->
    <!-- <div class="form-group col-12 mb-3">
      <label for="Surgeries" class="form-label">---------------------What Surgeries have you had? If none, write ‘none’.</label>
      <input type="text" class="form-control" id="Surgeries" formControlName="Surgeries" maxlength="100"
        placeholder="Enter Surgeries or 'none'">

      <div *ngIf="submitted && hospitalAdmissionsForm.controls['Surgeries']?.errors?.['required']" class="text-danger">
        This field is required.
      </div>

    </div> -->

    <!-- Immunizations -->
    <div class="form-group col-12 mb-3">
      <label class="form-label">{{ getTranslation('hospital.immunizations.title') }}</label>

      <div class="row gx-2">
        <div class="col-md-6 mb-2">
          <label for="Tetanus" class="form-label">{{ getTranslation('hospital.immunizations.tetanus') }}</label>
          <!-- <input type="text" class="form-control" id="Tetanus" formControlName="Tetanus" placeholder="Enter date"> -->


          <app-custome-year-picker formControlName="Tetanus" placeholder="{{ getTranslation('hospital.pickYear') }}" [minYear]="minYear"
            [maxYear]="maxYear">
          </app-custome-year-picker>



        </div>
        <div class="col-md-6 mb-2">
          <label for="Tb" class="form-label">{{ getTranslation('hospital.immunizations.tb') }}</label>
          <!-- <input type="text" class="form-control" id="Tb" formControlName="Tb" placeholder="Enter date"> -->


          <app-custome-year-picker formControlName="Tb" placeholder="{{ getTranslation('hospital.pickYear') }}" [minYear]="minYear" [maxYear]="maxYear">
          </app-custome-year-picker>




        </div>
      </div>

      <div class="row gx-2">
        <div class="col-md-6 mb-2">
          <label for="Polio" class="form-label">{{ getTranslation('hospital.immunizations.polio') }}</label>

          <!-- <input type="text" class="form-control" id="Polio" formControlName="Polio" placeholder="Enter date"> -->





          <app-custome-year-picker formControlName="Polio" placeholder="{{ getTranslation('hospital.pickYear') }}" [minYear]="minYear"
            [maxYear]="maxYear">
          </app-custome-year-picker>




        </div>
        <div class="col-md-6 mb-2">
          <label for="OtherImmunizations" class="form-label">{{ getTranslation('hospital.immunizations.other') }}</label>
          <input type="text" class="form-control" id="OtherImmunizations" formControlName="OtherImmunizations"
            placeholder="{{ getTranslation('hospital.enterDetails') }}"  maxlength="100">
        </div>
      </div>
    </div>

    <!-- Allergies -->
    <div class="form-group col-12 mb-3">
      <label class="form-label">{{ getTranslation('hospital.allergies.title') }}</label>

      <div class="row gx-2">
        <div class="col-md-4 mb-2">
          <label for="IsAllergicToMould" class="form-label"
            [ngClass]="{'text-danger': hospitalAdmissionsForm.controls['IsAllergicToMould'].invalid && submitted}">{{ getTranslation('hospital.allergies.mould') }}</label>

          <label class="ml-5 mr-5"><input type="radio" class="form-check-input" formControlName="IsAllergicToMould"
              [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
          <label><input type="radio" class="form-check-input" formControlName="IsAllergicToMould" [value]="false"
              class="me-2">
            {{ getTranslation('common.no') }}</label>


        </div>
        <div class="col-md-4 mb-2">
          <label for="IsAllergicToPollen" class="form-label"
            [ngClass]="{'text-danger': hospitalAdmissionsForm.controls['IsAllergicToPollen'].invalid && submitted}">{{ getTranslation('hospital.allergies.pollen') }}</label>



          <label class="ml-5 mr-5"><input type="radio" class="form-check-input" formControlName="IsAllergicToPollen"
              [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
          <label><input type="radio" class="form-check-input" formControlName="IsAllergicToPollen" [value]="false"
              class="me-2">
            {{ getTranslation('common.no') }}</label>


        </div>
        <div class="col-md-4 mb-2">
          <label for="IsAllergicToBeeSting" class="form-label"
            [ngClass]="{'text-danger': hospitalAdmissionsForm.controls['IsAllergicToBeeSting'].invalid && submitted}">{{ getTranslation('hospital.allergies.beeSting') }}</label>


          <label class="ml-5 mr-5"><input type="radio" class="form-check-input" formControlName="IsAllergicToBeeSting"
              [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
          <label><input type="radio" class="form-check-input" formControlName="IsAllergicToBeeSting" [value]="false"
              class="me-2">
            {{ getTranslation('common.no') }}</label>




        </div>
      </div>
    </div>

    <!-- Medicine Allergies -->
    <div class="form-group col-12 mb-3">
      <label for="MedicineAllergies" class="form-label">{{ getTranslation('hospital.medicineAllergies') }}</label>
      <input type="text" class="form-control" id="MedicineAllergies" formControlName="MedicineAllergies" [maxlength]="CONSTANTS.MaxLength.inputTextDescription"
        placeholder="{{ getTranslation('hospital.enterMedicineAllergies') }}">
    </div>

    <!-- Food Allergies -->
    <div class="form-group col-12 mb-3">
      <label for="FoodAllergies" class="form-label">{{ getTranslation('hospital.foodAllergies') }}</label>
      <input type="text" class="form-control" id="FoodAllergies" formControlName="FoodAllergies" [maxlength]="CONSTANTS.MaxLength.inputTextDescription"
        placeholder="{{ getTranslation('hospital.enterFoodAllergies') }}">
    </div>

    <!-- Other Allergies -->
    <div class="form-group col-12 mb-3">
      <label for="OtherAllergies" class="form-label">{{ getTranslation('hospital.otherAllergies') }}</label>
      <input type="text" class="form-control" id="OtherAllergies" formControlName="OtherAllergies" [maxlength]="CONSTANTS.MaxLength.inputTextDescription"
        placeholder="{{ getTranslation('hospital.enterOtherAllergies') }}">
    </div>


  </div>


  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="hospitalAdmissionsForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->



</form>